import _defineProperty from "/src/main/react/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _jsxFileName = "/src/main/react/src/main/app/components/pages/ContactSupport.js";
import React from 'react';
import TpicPage from './TpicPage';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { Grid, Typography, Button, TextField, Card, CardHeader, CardContent, CircularProgress } from '@material-ui/core';
import { BASE_URIS, SESSION_STORAGE_ITEM_NAMES } from "../domain/constants";
import { getSelectedPartner } from "../../util/Util";
const styles = () => ({
  paddedCard: {
    padding: '20px'
  },
  centeredDiv: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    margin: '50px',
    padding: '50px',
    height: '100%'
  }
});
const MODE = {
  compose: 'compose',
  mailSending: 'mailSending',
  mailSent: 'mailSent',
  mailError: 'mailError'
};
class ContactSupport extends TpicPage {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleChange", name => event => {
      this.setState({
        [name]: event.target.value
      });
    });
    this.state = {
      description: null,
      noDescriptionInput: false,
      // user tried to send a blank message
      mode: MODE.compose,
      errorReason: null
    };
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props != null && this.props.location != null && this.props.location.key !== prevProps.location.key) {
      this.setState({
        description: null,
        noDescriptionInput: false,
        mode: MODE.compose,
        errorReason: null
      });
    }
  }
  render() {
    const classes = this.props.classes;
    const _this$state = this.state,
      mode = _this$state.mode,
      noDescriptionInput = _this$state.noDescriptionInput;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.centeredDiv,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 61,
        columnNumber: 13
      }
    }, mode === MODE.compose && /*#__PURE__*/React.createElement(Card, {
      className: classes.paddedCard,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 63,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(CardHeader, {
      title: "Contact Support",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 64,
        columnNumber: 21
      }
    }), /*#__PURE__*/React.createElement(CardContent, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 65,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: 'column',
      alignContent: 'center',
      alignItems: 'center',
      justify: 'center',
      spacing: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 66,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 68,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 69,
        columnNumber: 33
      }
    }, "The email will be sent from the address associated with your account")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 72,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 73,
        columnNumber: 33
      }
    }, "Please describe your problem below")), noDescriptionInput === true && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 76,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: 'caption',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 77,
        columnNumber: 33
      }
    }, "Description is required")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      style: {
        width: '100%' /*of parent*/
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 80,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(TextField, {
      multiline: true,
      autoFocus: true,
      fullWidth: true,
      onChange: this.handleChange('description'),
      variant: 'outlined',
      error: noDescriptionInput,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 81,
        columnNumber: 33
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 84,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: () => this.handleSubmit(),
      variant: 'outlined',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 85,
        columnNumber: 33
      }
    }, "Send Email"))))), mode === MODE.mailSending && /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: 'column',
      alignContent: 'center',
      alignItems: 'center',
      justify: 'center',
      spacing: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 92,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 94,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(CircularProgress, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 95,
        columnNumber: 25
      }
    }))), mode === MODE.mailSent && /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: 'column',
      alignContent: 'center',
      alignItems: 'center',
      justify: 'center',
      spacing: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 100,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 102,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 103,
        columnNumber: 25
      }
    }, "Your support email has been sent successfully"))), mode === MODE.mailError && /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: 'column',
      alignContent: 'center',
      alignItems: 'center',
      justify: 'center',
      spacing: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 108,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 110,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 111,
        columnNumber: 25
      }
    }, "A problem occurred while attempting to send your mail")), this.state.errorReason != null && /*#__PURE__*/React.createElement(Typography, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 114,
        columnNumber: 21
      }
    }, "Message from server: ", this.state.errorReason)));
  }
  handleSubmit() {
    const description = this.state.description;
    const csrfToken = sessionStorage.getItem(SESSION_STORAGE_ITEM_NAMES.CSRFTOKEN);
    if (description != null && description !== '') {
      this.state.mode = MODE.mailSending;
      this.forceUpdate();
      fetch(BASE_URIS.supportMail, {
        method: 'POST',
        credentials: "include",
        body: JSON.stringify({
          body: description
        }),
        headers: {
          'Content-Type': 'application/json',
          'x-meta-tpic-partner': getSelectedPartner(),
          'x-meta-tpic-token': csrfToken
        }
      }).then(resp => {
        if (resp.ok === true) {
          this.state.mode = MODE.mailSent;
          this.forceUpdate();
        } else {
          if (resp.status === 400) {
            return resp.json();
          } else if (resp.status === 500) {
            this.state.mode = MODE.mailError;
            this.forceUpdate();
          }
        }
        return null;
      }).then(resp => {
        if (resp != null) {
          this.state.errorReason = resp.body;
          this.state.mode = MODE.mailError;
          this.forceUpdate();
        }
      }).catch(err => {
        console.error(err);
        this.state.mode = MODE.mailError;
        this.state.errorReason = 'Internal Server Error';
        this.forceUpdate();
      });
    } else {
      this.state.noDescriptionInput = true;
      this.forceUpdate();
    }
  }
}
export default withStyles(styles)(withRouter(ContactSupport));